import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const location = useLocation();

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <h1>eBay Feed System</h1>
          </div>
          <nav className="nav">
            <Link
              to="/"
              className={
                location.pathname === '/' ? 'nav-link active' : 'nav-link'
              }
            >
              🔍 Ricerca Prodotti
            </Link>
            <Link
              to="/dashboard"
              className={
                location.pathname === '/dashboard'
                  ? 'nav-link active'
                  : 'nav-link'
              }
            >
              📊 Dashboard
            </Link>
            <Link
              to="/imports"
              className={
                location.pathname === '/imports'
                  ? 'nav-link active'
                  : 'nav-link'
              }
            >
              📥 Importazioni
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
